var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10C5.83333 9.5398 6.20643 9.16671 6.66667 9.16671H13.3333C13.7936 9.16671 14.1667 9.5398 14.1667 10C14.1667 10.4603 13.7936 10.8334 13.3333 10.8334H6.66667C6.20643 10.8334 5.83333 10.4603 5.83333 10Z",
    fill: "#393B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.3334C6.20643 13.3334 5.83333 13.7065 5.83333 14.1667C5.83333 14.6269 6.20643 15 6.66667 15H13.3333C13.7936 15 14.1667 14.6269 14.1667 14.1667C14.1667 13.7065 13.7936 13.3334 13.3333 13.3334H6.66667Z",
    fill: "#393B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 0.833374C3.99238 0.833374 2.5 2.32576 2.5 4.16671V15.8334C2.5 17.6743 3.99238 19.1667 5.83333 19.1667H14.1667C16.0076 19.1667 17.5 17.6743 17.5 15.8334V7.57183C17.5 6.79204 17.2266 6.03693 16.7274 5.43788L13.8898 2.03276C13.2565 1.27278 12.3183 0.833374 11.3291 0.833374H5.83333ZM4.16667 4.16671C4.16667 3.24623 4.91286 2.50004 5.83333 2.50004H10.8333V5.00004C10.8333 6.84099 12.3257 8.33337 14.1667 8.33337H15.8333V15.8334C15.8333 16.7538 15.0871 17.5 14.1667 17.5H5.83333C4.91286 17.5 4.16667 16.7538 4.16667 15.8334V4.16671ZM15.5661 6.66671C15.5299 6.61065 15.4901 6.55659 15.447 6.50486L12.6094 3.09973C12.5747 3.05809 12.5382 3.01837 12.5 2.98066V5.00004C12.5 5.92051 13.2462 6.66671 14.1667 6.66671H15.5661Z",
    fill: "#393B4A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.e57c726149283c476df1815d857cdf78.svg";
export { ForwardRef as ReactComponent };